export const CATEGORIES = [
  "Alimentação", "Transporte", "Moradia", "Lazer", "Saúde",
  "Educação", "Contas/Serviços", "Trabalho", "Vendas", "Outros",
];

export const INCOME_CATEGORIES = ["Trabalho", "Vendas", "Outros"];

export const CATEGORY_COLORS = {
  "Alimentação": "#F59E0B",
  "Transporte": "#3B82F6",
  "Moradia": "#8B5CF6",
  "Lazer": "#EC4899",
  "Saúde": "#06B6D4",
  "Educação": "#10B981",
  "Contas/Serviços": "#64748B",
  "Trabalho": "#84CC16",
  "Vendas": "#22C55E",
  "Outros": "#A855F7",
};

export const CATEGORY_ICONS = {
  "Alimentação": "utensils",
  "Transporte": "car",
  "Moradia": "home",
  "Lazer": "gamepad-2",
  "Saúde": "heart-pulse",
  "Educação": "graduation-cap",
  "Contas/Serviços": "receipt",
  "Trabalho": "briefcase",
  "Vendas": "shopping-bag",
  "Outros": "circle-dot",
};

export const formatBRL = (n) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(Number(n || 0));

export const formatDate = (iso) => {
  try {
    return new Date(iso).toLocaleDateString("pt-BR", { day: "2-digit", month: "short" });
  } catch { return "-"; }
};

export const formatFullDate = (iso) => {
  try {
    return new Date(iso).toLocaleDateString("pt-BR", { day: "2-digit", month: "long", year: "numeric" });
  } catch { return "-"; }
};

export const PERIODS = [
  { key: "today", label: "Hoje" },
  { key: "week", label: "Semana" },
  { key: "month", label: "Mês" },
  { key: "year", label: "Ano" },
  { key: "all", label: "Todos" },
];

export function filterByPeriod(items, period) {
  if (period === "all") return items;
  const now = new Date();
  const start = new Date(now);
  if (period === "today") start.setHours(0, 0, 0, 0);
  else if (period === "week") { start.setDate(now.getDate() - 7); }
  else if (period === "month") { start.setMonth(now.getMonth()); start.setDate(1); start.setHours(0,0,0,0); }
  else if (period === "year") { start.setMonth(0); start.setDate(1); start.setHours(0,0,0,0); }
  return items.filter((t) => new Date(t.date) >= start);
}
